import {CommonModule} from '@angular/common'
import {HttpClient} from '@angular/common/http'
import {ChangeDetectorRef, Component, OnInit} from '@angular/core'
import {catchError, of} from 'rxjs';
import {ConfigService} from 'src/app/services/config.service';
import {LoadingService} from 'src/app/services/loading.service';
import {LegalService} from "../../services/legal.service";

@Component({
  selector: 'website-terms-of-use',
  standalone: true,
  templateUrl: './website-terms-of-use.component.html',
  styleUrl: './website-terms-of-use.component.scss',
  imports: [CommonModule]
})
export class WebsiteTermsOfUseComponent implements OnInit {
  text: any;

  constructor(private http: HttpClient,
              private cdr: ChangeDetectorRef,
              private loadingService: LoadingService,
              private configService: ConfigService,
              private legalService: LegalService
  ) {
  }

  ngOnInit() {
    this.loadingService.showLoading();
    this.http.get(this.legalService.getLegalDocument('terms-use')).pipe(
      catchError((error) => {
        console.error('Error occurred:', error);
        this.loadingService.hideLoading();
        return of({});
      })
    ).subscribe((data: any) => {
      this.text = this.getText(data['copy']);
      this.loadingService.hideLoading();
      this.cdr.markForCheck();
    });
  }

  private getText(data: any) {
    return decodeURIComponent(escape(atob(data)));
  }
}
